import { render, staticRenderFns } from "./UserMediaLibraryACL.vue?vue&type=template&id=cebb91fe&scoped=true&"
import script from "./UserMediaLibraryACL.vue?vue&type=script&lang=ts&"
export * from "./UserMediaLibraryACL.vue?vue&type=script&lang=ts&"
import style0 from "./UserMediaLibraryACL.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserMediaLibraryACL.vue?vue&type=style&index=1&id=cebb91fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebb91fe",
  null
  
)

export default component.exports